//console.log(process.env);
//process.env.NODE_ENV === "development"

export const API_PREFIX = process.env[`REACT_APP_API_ENDPOINT_${process.env.REACT_APP_THEME}`] || process.env.REACT_APP_API_ENDPOINT;
export const IS_DEVMODE = process.env.REACT_APP_IS_DEVMODE || 0;
